import cache_version from "cache_version.json";
import { Urls } from "interfaces/urls.interface";

export const urls: Urls = {
    API_HOST_URL: "https://api.worldpoverty.io",
    cacheVersion: cache_version
};
